import { useMemo } from 'react';

import { usePrivateAddOnFeatures } from '~/hooks/usePrivateAddOnFeatures';
import { DELETED_ITEM_TYPES } from '../constants/itemTypes';

export const useRecentlyDeletedItemTypes = () => {
  const { libraries: librariesFlag } = usePrivateAddOnFeatures();

  const values = useMemo(
    () => (librariesFlag ? DELETED_ITEM_TYPES : DELETED_ITEM_TYPES.filter((type) => type.id !== 'library')),
    [librariesFlag],
  );

  return values;
};
